(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am2-account"]) return;
  try {
    
document.querySelectorAll('[data-loyalty-profile]').forEach(async (profile) => {
  const xp = profile.querySelector('[data-loyalty-xp]');
  const level = profile.querySelector('[data-loyalty-level]');
  const rewards = profile.querySelector('[data-loyalty-rewards]');
  const list = profile.querySelector('[data-loyalty-rewards-list]');
  try {
    const response = await fetch(profile.dataset.loyaltyEndpoint, {credentials: 'same-origin'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'No se pudo cargar tu XP.');
    xp.textContent = `${data.xpBalance || 0} XP`;
    level.textContent = `${data.level || 'MIEMBRO'} · XP total: ${data.xpLifetime || 0}`;
    const active = Array.isArray(data.rewards) ? data.rewards.filter((reward) => reward.status === 'active') : [];
    if (active.length) {
      list.replaceChildren(...active.map((reward) => {
        const item = document.createElement('p');
        item.textContent = `${reward.code} · $${reward.mxn} MXN`;
        return item;
      }));
      rewards.hidden = false;
    }
  } catch (error) {
    xp.textContent = 'SIN SALDO DISPONIBLE';
    level.textContent = error.message || 'Actualiza la página e inténtalo de nuevo.';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am6-after-dashboard"]) return;
  try {
    
document.querySelectorAll('[data-loyalty-dashboard]').forEach(async (dashboard) => {
  const xp = dashboard.querySelector('[data-loyalty-xp]');
  const level = dashboard.querySelector('[data-loyalty-level]');
  const xpCopy = dashboard.querySelector('[data-loyalty-xp-copy]');
  const levelCopy = dashboard.querySelector('[data-loyalty-level-copy]');
  const rewards = dashboard.querySelector('[data-loyalty-rewards]');
  const rewardList = dashboard.querySelector('[data-loyalty-rewards-list]');
  try {
    const response = await fetch(dashboard.dataset.loyaltyEndpoint, {credentials: 'same-origin'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'No se pudo cargar tu XP.');
    xp.textContent = `${data.xpBalance || 0} XP`;
    level.textContent = data.level || 'MIEMBRO';
    xpCopy.textContent = `XP total: ${data.xpLifetime || 0}`;
    levelCopy.textContent = 'compras elegibles registradas';
    if (Array.isArray(data.rewards) && data.rewards.length) {
      const state = {active: 'ACTIVA', used: 'USADA', expired: 'VENCIDA'};
      rewardList.replaceChildren(...data.rewards.map((reward) => {
        const row = document.createElement('div');
        row.className = 'aw-dashboard__reward';
        const code = document.createElement('strong');
        code.textContent = reward.code;
        const detail = document.createElement('span');
        detail.textContent = `$${reward.mxn} MXN · ${state[reward.status] || 'ACTIVA'}`;
        row.append(code, detail);
        return row;
      }));
      rewards.hidden = false;
    }
  } catch (error) {
    xp.textContent = '—';
    level.textContent = 'SINCRONIZANDO';
    xpCopy.textContent = error.message || 'No se pudo cargar tu saldo.';
    levelCopy.textContent = 'intenta actualizar la página';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
